import React, {Component, Fragment} from 'react';
import {autobind} from 'core-decorators';
import {reverse} from 'core/urls';
import {signForm} from 'components/forms/decorators';
import createCLMultiplierTrialSignsOrderMutation from 'graphql/mutations/orders/create-cl-multiplier-trial-signs.gql';
import SectionBanner from 'components/section-banner';
import SectionTitle from 'components/section-title';
import OptionsSidebar from 'components/options-sidebar';
import ProductPicker from 'components/product-picker';
import {getDefaultAddress} from 'core/utils';
import AddressGrid from 'components/address-grid';
import {Form, Field, Textarea} from 'components/forms';
import Button from 'components/button';
import styles from '../styles.css';

@signForm(createCLMultiplierTrialSignsOrderMutation, 'cl_multiplier_trial_signs')
@autobind
export default class CLMultiplierTrialSignsCreate extends Component {
    render() {
        return (
            <div className={styles.root}>
                <SectionBanner />
                <SectionTitle title='Campo Líder Multiplicador' />
                <div className={styles.gridContainer}>
                    <OptionsSidebar
                        refundType='cl'
                        userType='multiplier'
                        links={['crops', 'refund', 'kits', 'trialSigns']}
                    />
                    <div className={styles.formContainer}>
                        <Form
                            fields={[
                                {key: 'items', initial: []},
                                {key: 'notes', required: false},
                                {
                                    key: 'address',
                                    initial: getDefaultAddress(this.props.addressesData),
                                },
                            ]}
                            errors={this.props.errors}
                            onSubmit={this.props.onSubmit}>
                            {({getFieldProps, renderErrors, isValid, values}) => (
                                <Fragment>
                                    <div className={styles.title}>Pedido de carteles</div>
                                    <p>
                                        Seleccioná los carteles para estacas que necesites para tu campo líder en
                                        función de lo que sembraste y la cantidad de bolsas que te fueron entregadas.
                                    </p>
                                    <Field>
                                        <ProductPicker
                                            items={this.props.itemsData.signs}
                                            perItemLimit={this.props.itemsData.perItemLimit}
                                            toggleSelectedProduct={this.props.toggleSelectedProduct}
                                            {...getFieldProps('items')}
                                        />
                                        {renderErrors('items')}
                                    </Field>
                                    <Field label='Comentarios para Nidera'>
                                        <Textarea {...getFieldProps('notes')} />
                                        {renderErrors('notes')}
                                    </Field>
                                    <Field label='Dirección de envío de los carteles'>
                                        <AddressGrid
                                            addresses={this.props.addressesData.addresses}
                                            returnUrl={reverse('clMultiplierTrialSignsCreate')}
                                            returnData={values}
                                            {...getFieldProps('address')}
                                        />
                                        {renderErrors('address')}
                                    </Field>
                                    {renderErrors('__all__')}
                                    <Form.Actions>
                                        <Button theme='yellow' disabled={!isValid() || this.props.loading}>
                                            {this.props.loading ? 'ENVIANDO...' : 'ENVIAR'}
                                        </Button>
                                        <p className={styles.reminder}>Recuerde seleccionar la organización correcta antes de enviar el pedido</p>
                                    </Form.Actions>
                                </Fragment>
                            )}
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/refunds/cl-multiplier/trial-signs/create/index.js